<template>
  <header>
    <img class="company-texture" src="../../../../src/assets/images/pages/company-header-texture.svg" />
    <div class="header__content">
      <h3 class="header__h3 mb-base">Get talent with high engagement</h3>
      <p class="header__p mb-1"><b>Tools to guide you towards Purposeful Opportunities</b></p>
      <p class="header__p mb-base">Build a resume portfolio and use the power of Predictive Talent Analytics & AI to predict your fit</p>
      <vs-button color="#FEBC00">HOW IT WORKS</vs-button>
    </div>
  </header>
</template>

<script>
  export default {
    name: "Header"
  }
</script>

<style scoped>
  .items-center {
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }
  button {
    border-radius: 50px;
  }
  header {
    height: 100vh;
    position: relative;
    background-image: url("../../../../src/assets/images/demo/company-header.png");
    background-position: center center;
    background-size: cover;
  }
  .company-texture {
    position: absolute;
    width: -webkit-fill-available;
    width: -moz-available;
  }
  .header__content {
    padding: 15rem 0rem 10rem 15rem;
    z-index: 999;
    width: 50%;
    z-index: 9999;
  }
  .header__content .header__h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 60px;
    line-height: 115%;
    letter-spacing: -0.04em;
    color: #FFFFFF;
  }
  .header__content .header__p {
    font-style: normal;
    /*font-weight: 500;*/
    font-size: 19px;
    line-height: 35px;
    letter-spacing: -0.01em;
    color: #FFFFFF;
  }



  /*===============================================*/
  /* MEDIA QUERIES	 						 */
  /*===============================================*/

  @media (max-width: 1200px) {
    section {
      padding: 5rem 2rem;
      background: #FFFFFF;
    }
    .header__content {
      width: -webkit-fill-available;
      width: -moz-available;
      padding: 10rem 2rem 5rem 2rem;
      text-align: center;
      text-align: -moz-center;
      text-align: -webkit-center;
    }
  }
</style>
